import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

interface InstructorRouteProps {
  children: React.ReactNode;
}

/**
 * Protected route component that ensures only instructors or admins can access
 * Redirects to dashboard if user doesn't have proper role
 */
export const InstructorRoute: React.FC<InstructorRouteProps> = ({ children }) => {
  const { user, userClaims, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // Check if user has instructor or admin role
  const hasInstructorAccess = userClaims?.role === 'instructor' || 
                              userClaims?.role === 'admin';

  if (!user || !hasInstructorAccess) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};